import { httpPost, httpDownload } from '../../../../utils/api.utils';
import { DEFAULT_TABLE_RESULT_MODEL } from '../../../../constants/external-constants';
import { getLocalTimeZone, convertToFormatTimeZoneDate } from '../../../../utils/helpers.utils';
import {
     setArticleHistoryLogsLoading
    , getArticleHistoryLogs
    , setArticleHistoryPageSize
    , resetArticleHistory
    , setArticleHistoryColSearchStr
} from '../../../../constants/model-reducers/external/recharge/article-catalogue/article-catalogue-history.settings';


const defaultState = () => ({
    HistoryTable: DEFAULT_TABLE_RESULT_MODEL,
    IsLoadingTable: false
});

const initialState = defaultState();

export const articleHistoryActions = {

    getArticleHistoryLogs: (articleId, pageIndex = 0) => async (dispatch, state) => {
        const { Pagination, Headers } = state().articleHistory.HistoryTable;
        var formData = {
            ArticleID: articleId,
            PageIndex: pageIndex,
            PageSize: Pagination.PerPage,
            PageSizes: Pagination.PageSizes,
            Headers: Headers,
           
        };

        dispatch({
            type: setArticleHistoryLogsLoading,
            isLoadingTable: true
        });

        var result = await httpPost('external/recharge/getArticleHistoryLogs', formData);

        dispatch({
            type: getArticleHistoryLogs,
            historyTable: result,
            isLoadingTable: false
        });
    },

    resizeArticleHistoryLogs: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setArticleHistoryPageSize,
            pageSize: parseInt(pageSize),
        });
    },

    setArticleHistoryColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { HistoryTable } = state().articleHistory;
        var historyTableHeaderUpd = {
            ...HistoryTable,
            "Headers": {
                ...HistoryTable.Headers,
                [key]: {

                    ...HistoryTable.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setArticleHistoryColSearchStr,
            historyTable: historyTableHeaderUpd
        });
    },

    resetArticleHistory: () => (dispatch, state) => {
        dispatch({
            type: resetArticleHistory
        })
    },

    extractArticleHistoryLogs: (articleId) => async (dispatch, state) => {
        const { Headers } = state().articleHistory.HistoryTable;
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;

        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\|?*]/g, '-');
        const filename = `ATEM ${dealName} Article History – ${formattedTimeZoneDate}`;

        var formData = {
            ArticleID: articleId,
            Headers: Headers,
            FileName: filename,
            TimeZone: getLocalTimeZone()
        };
        httpDownload('external/recharge/getExtractArticleHistoryLogs', formData)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setArticleHistoryLogsLoading:
            return {
                ...state,
                IsLoadingTable: action.isLoadingTable
            }
        case getArticleHistoryLogs:
            return {
                ...state,
                HistoryTable: action.historyTable,
                IsLoadingTable: action.isLoadingTable
            }
        case setArticleHistoryPageSize:
            return {
                ...state,
                HistoryTable: {
                    ...state.HistoryTable,
                    Pagination: {
                        ...state.HistoryTable.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case setArticleHistoryColSearchStr:
            return {
                ...state,
                HistoryTable: action.historyTable,
            }
        case resetArticleHistory:
            return initialState;
        default:
            return state;
    }
}